// @flow

import React from "react";

import * as colors from "src/styles/constants/colors";

type Props = {
  size?: number,
  color?: string,
  style?: Object
};

const Process = ({ size = 50, color = colors.grey42, style = {} }: Props) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Process Icon"
      style={{ ...style }}
    >
      <defs>
        <mask
          id="mask0_1767_1168"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={`${size}`}
          height={`${size}`}
        >
          <rect x="0" y="0" width={`${size}`} height={`${size}`} fill="white" />
        </mask>
      </defs>
      <g mask="url(#mask0_1767_1168)">
        <path
          d="M20.2579 40.5257C20.8641 40.5257 21.3718 40.3207 21.781 39.9106C22.1898 39.5006 22.3942 38.9925 22.3942 38.3863C22.3942 37.7801 22.1892 37.2724 21.7792 36.8632C21.3692 36.4544 20.8611 36.25 20.2549 36.25C19.6487 36.25 19.1412 36.455 18.7324 36.865C18.3232 37.2751 18.1185 37.7832 18.1185 38.3893C18.1185 38.9955 18.3236 39.503 18.7336 39.9118C19.144 40.3211 19.6521 40.5257 20.2579 40.5257ZM20.2579 31.1375C20.8641 31.1375 21.3718 30.9325 21.781 30.5225C22.1898 30.1125 22.3942 29.6044 22.3942 28.9982C22.3942 28.392 22.1892 27.8845 21.7792 27.4757C21.3692 27.0669 20.8611 26.8625 20.2549 26.8625C19.6487 26.8625 19.1412 27.0675 18.7324 27.4775C18.3232 27.8875 18.1185 28.3956 18.1185 29.0018C18.1185 29.608 18.3236 30.1155 18.7336 30.5243C19.144 30.9331 19.6521 31.1375 20.2579 31.1375ZM20.2579 21.75C20.8641 21.75 21.3718 21.545 21.781 21.135C22.1898 20.7249 22.3942 20.2168 22.3942 19.6106C22.3942 19.0045 22.1892 18.497 21.7792 18.0881C21.3692 17.6789 20.8611 17.4743 20.2549 17.4743C19.6487 17.4743 19.1412 17.6793 18.7324 18.0893C18.3232 18.4994 18.1185 19.0075 18.1185 19.6137C18.1185 20.2198 18.3236 20.7275 18.7336 21.1368C19.144 21.5456 19.6521 21.75 20.2579 21.75ZM27.5997 40.2H41.356V36.5756H27.5997V40.2ZM27.5997 30.8125H41.356V27.1875H27.5997V30.8125ZM27.5997 21.4243H41.356V17.8H27.5997V21.4243ZM13.6109 49.5417C12.39 49.5417 11.3567 49.1187 10.5109 48.2729C9.66504 47.4271 9.24213 46.3937 9.24213 45.1729V12.8271C9.24213 11.6062 9.66504 10.5729 10.5109 9.72708C11.3567 8.88124 12.39 8.45833 13.6109 8.45833H45.9567C47.1775 8.45833 48.2109 8.88124 49.0567 9.72708C49.9025 10.5729 50.3255 11.6062 50.3255 12.8271V45.1729C50.3255 46.3937 49.9025 47.4271 49.0567 48.2729C48.2109 49.1187 47.1775 49.5417 45.9567 49.5417H13.6109ZM13.6109 45.9167H45.9567C46.1428 45.9167 46.3132 45.8391 46.4679 45.6841C46.6229 45.5294 46.7005 45.359 46.7005 45.1729V12.8271C46.7005 12.641 46.6229 12.4706 46.4679 12.3159C46.3132 12.1609 46.1428 12.0833 45.9567 12.0833H13.6109C13.4248 12.0833 13.2544 12.1609 13.0997 12.3159C12.9447 12.4706 12.8671 12.641 12.8671 12.8271V45.1729C12.8671 45.359 12.9447 45.5294 13.0997 45.6841C13.2544 45.8391 13.4248 45.9167 13.6109 45.9167Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Process;
